import { useEffect, useRef, useState } from 'react';
import jquery from 'jquery';
import 'summernote/dist/summernote-lite.min.js';
import 'summernote/dist/summernote-lite.min.css';
import 'summernote/dist/lang/summernote-ko-KR';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getMAGAC020, getMAGAC020options, postMAGAC020, putMAGAC020, deleteMAGAC020 } from '../../../services/Api';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_MENUS, MESSAGE } from '../../../shared/constants/app';

import moment from 'moment';
import DatePicker from 'react-datepicker';
import CheckGroup from '../../../shared/components/CheckGroup';

import { formatDate, getImageSrc, handleFocus } from '../../../utils';

const SUMMERNOTE_TOOLBAR = [
    ['style', ['style']],
    ['font', ['bold', 'italic', 'underline', 'clear']],
    ['color', ['color']],
    ['para', ['ul', 'ol', 'paragraph']],
    ['table', ['table']],
    ['insert', ['link', 'picture', 'video']],
    ['view', ['codeview']],
];

const MAGAC020 = () => {
    const startDateRef = useRef();
    const endDateRef = useRef();
    const { id } = useParams();
    const [data, setData] = useState({ dspYN: 'N' });
    const [appGbnTarget, setAppGbnTarget] = useState([]);
    const [checkedValues, setCheckedValues] = useState(['A']);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [fileData, setFileData] = useState({});
    const [surveyQuestions, setSurveyQuestions] = useState([]);
    const [giftItems, setGiftItems] = useState([]);
    const navigate = useNavigate();
    const editorWebRef = useRef();
    const editorAppRef = useRef();

    useEffect(() => {
        jquery(editorWebRef.current).summernote({
            height: 300,
            lang: 'ko-KR',
            placeholder: '내용을 입력하세요...',
            toolbar: SUMMERNOTE_TOOLBAR,
        });
        jquery(editorAppRef.current).summernote({
            height: 300,
            lang: 'ko-KR',
            placeholder: '내용을 입력하세요...',
            toolbar: SUMMERNOTE_TOOLBAR,
        });

        return () => {
            jquery(editorWebRef.current).summernote('destroy');
            jquery(editorAppRef.current).summernote('destroy');
        };
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const { data: optionsData } = await getMAGAC020options();
                setAppGbnTarget(optionsData);

                setSurveyQuestions([]);
                setGiftItems([]);

                if (id) {
                    const { data: resData } = await getMAGAC020(id);

                    setData({
                        title: resData.title || '',
                        eventGbn: resData.eventGbn || '',
                        dspYN: resData.dspYN || 'Y',
                        webImg: resData.webImg || '',
                        // appImg: resData.appImg || '',
                        target: resData.target || 'A',
                        replyYn: resData.replyYn || 'N',
                    });

                    setStartDate(resData.startDate ? formatDate(resData.startDate) : '');
                    setEndDate(resData.endDate ? formatDate(resData.endDate) : '');
                    setCheckedValues(resData.appGbnTarget ? resData.appGbnTarget.split(',') : ['A']);

                    jquery(editorWebRef.current).summernote('code', resData.contents || '');
                    // jquery(editorAppRef.current).summernote('code', resData.contentsApp || '');

                    setFileData({
                        webImg: resData.webImg
                            ? { name: resData.webImg, preview: getImageSrc('event', resData.webImg) }
                            : {},
                        // appImg: resData.appImg
                        //     ? { name: resData.appImg, preview: getImageSrc('event', resData.appImg) }
                        //     : {},
                    });

                    setSurveyQuestions(
                        (resData.questions || []).map((q) => ({
                            id: Date.now() + Math.random(),
                            seq: q.seq || null,
                            type: q.type || 'S',
                            shortAnswerYn: q.shortAnswerYn || 'N',
                            title: q.title || '',
                            subTitle: q.subTitle || '',
                            options: (q.options || [])
                                .filter((opt) => opt.optionText !== '기타(직접입력)')
                                .map((opt) => ({
                                    id: opt.optionNo,
                                    optionId: opt.optionId || null,
                                    optionText: opt.optionText || '',
                                })),
                        }))
                    );

                    const loadedGifts = await Promise.all(
                        (resData.gifts || []).map(async (g, idx) => {
                            const originalGiftImgName = g.giftImgName || g.webImgName || g.appImgName || '';
                            let originalImageFile = null;

                            if (originalGiftImgName) {
                                try {
                                    const res = await fetch(getImageSrc('gift', originalGiftImgName));
                                    if (res.ok) {
                                        const blob = await res.blob();
                                        originalImageFile = new File([blob], originalGiftImgName, {
                                            type: blob.type || 'application/octet-stream',
                                        });
                                    }
                                } catch (error) {
                                    console.log(error);
                                }
                            }

                            return {
                                id: crypto.randomUUID(),
                                giftId: g.giftId || null,
                                giftName: g.giftName || '',
                                image: originalImageFile,
                                giftImgName: originalGiftImgName || null,
                                webImgName: g.webImgName || originalGiftImgName || null,
                                appImgName: g.appImgName || null,
                                preview: originalGiftImgName ? getImageSrc('gift', originalGiftImgName) : null,
                            };
                        })
                    );
                    setGiftItems(loadedGifts);
                }
            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
        // eslint-disable-next-line
    }, [id]);

    const handleDelete = () => {
        const isConfirm = window.confirm(MESSAGE.confirm.delete);
        if (isConfirm) {
            deleteMAGAC020(id)
                .then(() => {
                    window.alert(MESSAGE.notify.deleteSuccess);
                    window.location.href = '/magac010';
                })
                .catch((error) => console.log(error));
        }
    };

    const getOptions = () => {
        const defaultOptions = [{ id: 'target_A', value: 'A', label: '전체' }];
        const additionalOptions = appGbnTarget.map((target) => ({
            id: 'target_' + target.code,
            value: target.code,
            label: target.codeName,
        }));
        return [...defaultOptions, ...additionalOptions];
    };

    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        setCheckedValues((prevValues) => {
            const prev = Array.isArray(prevValues) ? prevValues : [];
            if (checked) {
                if (value === 'A') return ['A'];
                return [...prev.filter((v) => v !== 'A'), value];
            } else {
                return prev.filter((v) => v !== value);
            }
        });
    };

    const handleDateChange = (date, name) => {
        const newStartDate = name === 'startDate' ? date : startDate;
        const newEndDate = name === 'endDate' ? date : endDate;

        if (name === 'startDate') setStartDate(date);
        else if (name === 'endDate') setEndDate(date);

        // dspYN이 체크되어 있으면 날짜와 상관없이 그대로 유지한다.
        // 체크 해제 상태에서 startDate, endDate가 모두 입력되면(둘 중 하나를 변경할 때마다),
        // 표시기간(startDate <= today <= endDate)에 오늘이 포함되면 자동으로 체크한다.
        if (data?.dspYN !== 'Y' && newStartDate && newEndDate) {
            const today = moment().startOf('day');
            const startOk = moment(newStartDate).startOf('day').isSameOrBefore(today);
            const endOk = moment(newEndDate).startOf('day').isSameOrAfter(today);

            if (startOk && endOk) {
                setData((prev) => ({ ...prev, dspYN: 'Y' }));
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        const fieldName = e.target.id;
        if (selectedFile) {
            const previewUrl = URL.createObjectURL(selectedFile);
            setFileData((prev) => ({
                ...prev,
                [fieldName]: { name: selectedFile.name, preview: previewUrl, file: selectedFile },
            }));
        }
    };

    const handleAddGiftItem = () => {
        if (giftItems.length >= 4) {
            alert('사은품은 최대 4개까지 추가할 수 있습니다.');
            return;
        }
        setGiftItems((prev) => [...prev, { id: crypto.randomUUID(), giftName: '', image: null, preview: null }]);
    };

    const handleGiftNameChange = (giftId, value) => {
        setGiftItems((prev) => prev.map((item) => (item.id === giftId ? { ...item, giftName: value } : item)));
    };

    const handleGiftImageChange = (giftId, file) => {
        if (!file) return;

        setGiftItems((prev) =>
            prev.map((item) =>
                item.id === giftId
                    ? {
                        ...item,
                        image: file,
                        giftImgName: file.name,
                        preview: URL.createObjectURL(file),
                    }
                    : item
            )
        );
    };

    const handleDeleteGiftItem = (giftId) => {
        setGiftItems((prev) => prev.filter((item) => item.id !== giftId));
    };

    const handleAddQuestion = () => {
        if (surveyQuestions.length >= 10) {
            alert('문항은 최대 10개까지 추가할 수 있습니다.');
            return;
        }
        setSurveyQuestions([
            ...surveyQuestions,
            { id: Date.now(), type: 'S', shortAnswerYn: 'N', title: '', subTitle: '', options: [{ id: 1, optionText: '' }] },
        ]);
    };

    const handleDeleteQuestion = (questionId) => {
        setSurveyQuestions(surveyQuestions.filter((q) => q.id !== questionId));
    };

    const handleQuestionChange = (questionId, field, value) => {
        setSurveyQuestions(surveyQuestions.map((q) => (q.id === questionId ? { ...q, [field]: value } : q)));
    };

    const handleOptionChange = (questionId, optionId, value) => {
        setSurveyQuestions(
            surveyQuestions.map((q) =>
                q.id === questionId
                    ? { ...q, options: q.options.map((opt) => (opt.id === optionId ? { ...opt, optionText: value } : opt)) }
                    : q
            )
        );
    };

    const handleShortAnswerToggle = (questionId, checked) => {
        const question = surveyQuestions.find((q) => q.id === questionId);
        if (checked && question && question.options.length >= 30) {
            alert('항목은 최대 30개까지 등록할 수 있습니다.\n주관식(기타)을 추가하려면 항목을 1개 삭제해 주세요.');
            return;
        }
        if (!checked && question && question.options.length === 0) {
            alert('항목은 최소 1개 이상 등록해야 합니다.');
            return;
        }
        handleQuestionChange(questionId, 'shortAnswerYn', checked ? 'Y' : 'N');
    };

    const handleAddOption = (questionId) => {
        setSurveyQuestions(
            surveyQuestions.map((q) => {
                if (q.id !== questionId) return q;
                const maxOptions = q.shortAnswerYn === 'Y' ? 29 : 30;
                if (q.options.length >= maxOptions) {
                    alert(`항목은 최대 ${maxOptions}개까지 등록할 수 있습니다.`);
                    return q;
                }
                return {
                    ...q,
                    options: [...q.options, { id: Math.max(...q.options.map((o) => o.id), 0) + 1, optionText: '' }],
                };
            })
        );
    };

    const handleDeleteOption = (questionId, optionId) => {
        const question = surveyQuestions.find((q) => q.id === questionId);
        if (question && question.options.length <= 1 && question.shortAnswerYn !== 'Y') {
            alert('항목은 최소 1개 이상 등록해야 합니다.');
            return;
        }
        setSurveyQuestions(
            surveyQuestions.map((q) =>
                q.id === questionId ? { ...q, options: q.options.filter((opt) => opt.id !== optionId) } : q
            )
        );
    };

    const handleSave = async () => {
        if (!data.title) {
            alert('제목을 입력해 주세요.');
            handleFocus('title');
            return;
        }
        if (startDate === '' || endDate === '') {
            alert('진행기간을 선택해 주세요.');
            handleFocus(startDate === '' ? 'startDate' : 'endDate');
            return;
        }

        const contentsWeb = jquery(editorWebRef.current).summernote('code');
        // const contentsApp = jquery(editorAppRef.current).summernote('code');

        const stripHtml = (html) =>
            html
                .replace(/<\/p>/gi, '\n')
                .replace(/<br\/?>/gi, '\n')
                .replace(/<\/?[^>]+(>|$)/g, '');

        const questions =
            data.eventGbn === 'QUE'
                ? surveyQuestions.map((q) => {
                    const baseOptions = q.options.map((opt, idx) => ({
                        ...(opt.optionId && { optionId: opt.optionId }),
                        optionNo: idx + 1,
                        optionText: opt.optionText,
                    }));

                    const finalOptions =
                        q.shortAnswerYn === 'Y'
                            ? [
                                ...baseOptions,
                                {
                                    optionNo: baseOptions.length + 1,
                                    optionText: '기타(직접입력)',
                                },
                            ]
                            : baseOptions;

                    return {
                        ...(q.seq && { seq: q.seq }),
                        type: q.type,
                        shortAnswerYn: q.shortAnswerYn || 'N',
                        title: q.title,
                        subTitle: q.subTitle,
                        options: finalOptions,
                    };
                }) : undefined;

        const gifts = ['RVW', 'QUE'].includes(data.eventGbn)
            ? giftItems.map((item) => ({
                ...(item.giftId && { giftId: item.giftId }),
                giftName: item.giftName,
                ...(!item.image && item.webImgName && { webImgName: item.webImgName }),
                ...(!item.image && item.appImgName && { appImgName: item.appImgName }),
            }))
            : undefined;

        const payload = {
            title: data.title,
            eventGbn: data.eventGbn || 'EVT',
            target: data.target || 'A',
            appGbnTarget: Array.isArray(checkedValues) && checkedValues.length ? checkedValues.join(',') : 'A',
            dspYN: data.dspYN || 'Y',
            replyYn: data.replyYn || 'N',
            contents: contentsWeb,
            ftsContents: stripHtml(contentsWeb),
            // contentsApp: contentsApp,
            // ftsContentsApp: stripHtml(contentsApp),
            startDate: startDate ? moment(startDate).format('YYYY-MM-DD') + ' 00:00:00' : '',
            endDate: endDate ? moment(endDate).format('YYYY-MM-DD') + ' 23:59:59' : '',
            webImg: fileData.webImg?.name || '',
            appImg: fileData.appImg?.name || '',
            ...(questions && { questions }),
            ...(gifts && { gifts }),
        };

        if (id) payload.seq = id;

        const isConfirmed = window.confirm('등록/수정하시겠습니까?');
        if (!isConfirmed) return;

        const apiCall = id ? putMAGAC020 : postMAGAC020;
        const formData = new FormData();

        formData.append('data', new Blob([JSON.stringify(payload)], { type: 'application/json' }));
        if (fileData.webImg?.file) formData.append('webImg', fileData.webImg.file);
        if (fileData.appImg?.file) formData.append('appImg', fileData.appImg.file);
        giftItems.forEach((item) => {
            if (item.image instanceof File || item.image instanceof Blob) {
                formData.append(
                    'giftImgs',
                    item.image,
                    item.image.name || item.giftImgName || 'gift-img'
                );
            }
        });

        apiCall(formData)
            .then(() => {
                window.alert('등록/수정되었습니다.');
                navigate('/magac010');
            })
            .catch((error) => {
                console.log(error);
                window.alert(MESSAGE.notify.updateError);
            });
    };

    const TrashIcon = () => (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 5V19C18 19.5 17.5 20 17 20H12H7C6.5 20 6 19.5 6 19V5" stroke="#5D5D5D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4 5H20" stroke="#5D5D5D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 4H14M10 9V16M14 9V16" stroke="#5D5D5D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_MENUS} />
                <div className="content-right list-event">
                    <h1 className="title">{!id ? '이벤트 등록' : '이벤트 수정'}</h1>
                    <table className="table member-infor">
                        <tbody>
                            <tr>
                                <th>제목</th>
                                <td colSpan={3}>
                                    <input type="text" name="title" value={data?.title || ''} onChange={handleChange} />
                                </td>
                            </tr>
                            <tr>
                                <th className="border-t-ddd">이벤트 타입</th>
                                <td colSpan={3} className="border-t-ddd">
                                    <select onChange={handleChange} value={data?.eventGbn || ''} name="eventGbn">
                                        <option value="EVT">일반형</option>
                                        <option value="RVW">댓글형</option>
                                        <option value="QUE">설문형</option>
                                    </select>
                                </td>
                            </tr>
                            {data?.eventGbn === 'RVW' && (
                                <tr>
                                    <th className="border-t-ddd">대댓글</th>
                                    <td colSpan={3} className="border-t-ddd">
                                        <div className="item-checkBox">
                                            <input
                                                id="replyYn"
                                                type="checkbox"
                                                checked={data?.replyYn === 'Y'}
                                                onChange={(e) =>
                                                    setData({ ...data, replyYn: e.target.checked ? 'Y' : 'N' })
                                                }
                                            />
                                            <span />
                                            <label htmlFor="replyYn">허용</label>
                                        </div>
                                    </td>
                                </tr>
                            )}
                            {data?.eventGbn === 'QUE' && (
                                <tr>
                                    <th className="border-t-ddd">문항 구성</th>
                                    <td colSpan={3} className="border-t-ddd">
                                        <div className="survey-add-question-container">
                                            <button type="button" className="button-add" onClick={handleAddQuestion}>
                                                <span>문항 추가</span>
                                                <span className="button-add-icon">+</span>
                                            </button>
                                        </div>
                                        {surveyQuestions.map((question, index) => (
                                            <div key={question.id} className="survey-question-form">
                                                <div className="survey-question-header d-flex align-items-center justify-content-between gap-3 p-0 mb-3">
                                                    <div className="d-flex align-items-center gap-4">
                                                        <span className="survey-question-number">문항 {index + 1}</span>
                                                        <div className="survey-response-type d-flex align-items-center gap-3">
                                                            <label className="survey-response-label">응답 유형</label>
                                                            <div className="survey-radio-group">
                                                                <div className="survey-radio-item">
                                                                    <input
                                                                        type="radio"
                                                                        id={`radio-single-${question.id}`}
                                                                        name={`response-${question.id}`}
                                                                        value="S"
                                                                        checked={question.type === 'S'}
                                                                        onChange={(e) => handleQuestionChange(question.id, 'type', e.target.value)}
                                                                    />
                                                                    <label htmlFor={`radio-single-${question.id}`}>단일선택</label>
                                                                </div>
                                                                <div className="survey-radio-item">
                                                                    <input
                                                                        type="radio"
                                                                        id={`radio-multiple-${question.id}`}
                                                                        name={`response-${question.id}`}
                                                                        value="M"
                                                                        checked={question.type === 'M'}
                                                                        onChange={(e) => handleQuestionChange(question.id, 'type', e.target.value)}
                                                                    />
                                                                    <label htmlFor={`radio-multiple-${question.id}`}>다중선택</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button
                                                        type="button"
                                                        onClick={() => handleDeleteQuestion(question.id)}
                                                        className="survey-delete-btn p-0 btn-remove-hv"
                                                    >
                                                        <TrashIcon />
                                                    </button>
                                                </div>
                                                <div className="survey-question-body">
                                                    <div className="survey-field-input border-bottom border-ddd pb-4">
                                                        <div className="survey-field d-flex align-items-center mb-3">
                                                            <label>제목</label>
                                                            <input
                                                                className="w-100"
                                                                type="text"
                                                                placeholder="문항 제목을 입력하세요."
                                                                value={question.title}
                                                                onChange={(e) => handleQuestionChange(question.id, 'title', e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="survey-field d-flex align-items-center">
                                                            <label>부제목</label>
                                                            <input
                                                                className="w-100"
                                                                type="text"
                                                                placeholder="문항 부제목을 입력하세요."
                                                                value={question.subTitle}
                                                                onChange={(e) => handleQuestionChange(question.id, 'subTitle', e.target.value)}
                                                            />
                                                        </div>
                                                        <div className="survey-field d-flex align-items-center mt-3">
                                                            <label>주관식</label>
                                                            <div className="item-checkBox">
                                                                <input
                                                                    id={`shortAnswer-${question.id}`}
                                                                    type="checkbox"
                                                                    checked={question.shortAnswerYn === 'Y'}
                                                                    onChange={(e) =>
                                                                        handleShortAnswerToggle(question.id, e.target.checked)
                                                                    }
                                                                />
                                                                <span />
                                                                <label htmlFor={`shortAnswer-${question.id}`}>허용</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="survey-options mb-3">
                                                        <div className="survey-options-more">
                                                            <label>항목</label>
                                                            {question.options.map((option) => (
                                                                <div key={option.id} className="survey-option-item d-flex align-items-center gap-3 mb-3">
                                                                    <div className="survey-option-number">
                                                                        {String(question.options.indexOf(option) + 1).padStart(2, '0')}
                                                                    </div>
                                                                    <input
                                                                        className="w-100"
                                                                        type="text"
                                                                        placeholder="항목을 입력하세요."
                                                                        value={option.optionText}
                                                                        onChange={(e) => handleOptionChange(question.id, option.id, e.target.value)}
                                                                    />
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => handleDeleteOption(question.id, option.id)}
                                                                        className="survey-option-delete btn-remove-hv p-0"
                                                                    >
                                                                        <TrashIcon />
                                                                    </button>
                                                                </div>
                                                            ))}
                                                            {question.shortAnswerYn === 'Y' && (
                                                                <div className="survey-option-item d-flex align-items-center gap-3 mb-3">
                                                                    <div className="survey-option-number">
                                                                        {String(question.options.length + 1).padStart(2, '0')}
                                                                    </div>
                                                                    <input
                                                                        className="w-100"
                                                                        type="text"
                                                                        value="기타(직접입력)"
                                                                        readOnly
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                        <button type="button" onClick={() => handleAddOption(question.id)} className="survey-add-option">
                                                            항목 추가<span>+</span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </td>
                                </tr>
                            )}
                            <tr>
                                <th className="border-t-ddd">대상회원</th>
                                <td colSpan={3} className="border-t-ddd">
                                    <select onChange={handleChange} value={data?.target || 'A'} name="target">
                                        <option value="A">전체</option>
                                        <option value="C">치과회원</option>
                                        <option value="P">개인회원</option>
                                    </select>
                                </td>
                            </tr>
                            <tr>
                                <th className="border-t-ddd">회원구분</th>
                                <td colSpan={3}>
                                    <div className="d-flex flex-wrap gap-3">
                                        <CheckGroup
                                            name="appGbnTarget"
                                            options={getOptions()}
                                            checkedValues={checkedValues}
                                            onChange={handleCheckboxChange}
                                            type="checkbox"
                                        />
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th>진행기간</th>
                                <td>
                                    <div className="flex group-item">
                                        <div className="group-datepicker">
                                            <div className="datepicker-child">
                                                <DatePicker
                                                    ref={startDateRef}
                                                    onChange={(date) => handleDateChange(date, 'startDate')}
                                                    locale={'ko'}
                                                    placeholderText={'YYYY/MM/DD'}
                                                    dateFormat={'yyyy/MM/dd'}
                                                    selected={startDate}
                                                    id="startDate"
                                                    maxDate={endDate || null}
                                                />
                                                <i className="icon icon-date" id="start-date-icon" onClick={() => startDateRef.current.setFocus()} />
                                            </div>
                                            <span>~</span>
                                            <div className="datepicker-child">
                                                <DatePicker
                                                    ref={endDateRef}
                                                    onChange={(date) => handleDateChange(date, 'endDate')}
                                                    locale={'ko'}
                                                    placeholderText={'YYYY/MM/DD'}
                                                    dateFormat={'yyyy/MM/dd'}
                                                    id="endDate"
                                                    selected={endDate}
                                                    minDate={startDate || null}
                                                />
                                                <i className="icon icon-date" id="end-date-icon" onClick={() => endDateRef.current.setFocus()} />
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            {/* <tr>
                                <th>진행상태</th>
                                <td className="border-t-ddd">
                                    <select onChange={handleChange} value={data?.isEnd || ''} name="isEnd">
                                        <option value="">진행예정</option>
                                        <option value="N">진행</option>
                                        <option value="Y">마감</option>
                                    </select>
                                </td>
                            </tr> */}
                            <tr>
                                <th>강제 공개 여부</th>
                                <td>
                                    <div className="item-checkBox">
                                        <input
                                            id="dspYN"
                                            type="checkbox"
                                            checked={data?.dspYN === 'Y'}
                                            onChange={(e) =>
                                                setData({ ...data, dspYN: e.target.checked ? 'Y' : 'N' })
                                            }
                                        />
                                        <span />
                                        <label htmlFor="dspYN">예</label>
                                    </div>
                                </td>
                            </tr>
                            {/* <tr>
                                <th>
                                    APP 썸네일
                                    <br />
                                    <span style={{ fontSize: '12px' }}>(사이즈: 510 * 160 픽셀)</span>
                                </th>
                                <td colSpan={3}>
                                    <div>
                                        <div className="result-input-file">
                                            {fileData.appImg?.preview && (
                                                <img src={fileData.appImg.preview} alt="Preview" className="event__image" />
                                            )}
                                        </div>
                                        <input
                                            id="appImg"
                                            type="file"
                                            accept="image/*"
                                            name="appImg"
                                            onChange={handleFileChange}
                                            className="custom-input hidden-file-input"
                                        />
                                        <label htmlFor="appImg" className="custom-label-file">파일첨부</label>
                                    </div>
                                </td>
                            </tr> */}
                            <tr>
                                <th>
                                    썸네일
                                </th>
                                <td colSpan={3}>
                                    <div>
                                        <div className="result-input-file">
                                            {fileData.webImg?.preview && (
                                                <img src={fileData.webImg.preview} alt="Preview" className="event__image" />
                                            )}
                                        </div>
                                        <input
                                            id="webImg"
                                            type="file"
                                            accept="image/*"
                                            name="webImg"
                                            onChange={handleFileChange}
                                            className="custom-input hidden-file-input"
                                        />
                                        <label htmlFor="webImg" className="custom-label-file">파일첨부</label>
                                        <span className="thumbnail-size-hint">(썸네일 이미지크기 : 542 * 169픽셀)</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th className="border-t-ddd">상세내용</th>
                                <td>
                                    <div style={{ height: 300 }} ref={editorWebRef}></div>
                                </td>
                                {/* <th className="border-t-ddd">상세내용 (APP)</th>
                                <td>
                                    <div style={{ height: 300 }} ref={editorAppRef}></div>
                                </td> */}
                            </tr>
                            {['RVW', 'QUE'].includes(data?.eventGbn) && (
                                <tr>
                                    <th className="border-t-ddd">사은품 구성</th>
                                    <td colSpan={3} className="border-t-ddd">
                                        <div className="survey-add-question-container">
                                            <button type="button" className="button-add" onClick={handleAddGiftItem}>
                                                <span>사은품 추가</span>
                                                <span className="button-add-icon">+</span>
                                            </button>
                                        </div>
                                        {giftItems.length > 0 && (
                                            <div className="gift-item-list mt-4">
                                                {giftItems.map((item, index) => {
                                                    const giftImageInputId = `gift-image-${item.id}`;

                                                    return (
                                                        <div className="gift-item-row" key={item.id}>
                                                            <div className="gift-item-badge">사은품 {index + 1}</div>
                                                            <div className="gift-item-content">
                                                                <div className="gift-item-field">
                                                                    <label>사은품명</label>
                                                                    <input
                                                                        type="text"
                                                                        value={item.giftName}
                                                                        placeholder="사은품명을 입력해주세요."
                                                                        onChange={(e) => handleGiftNameChange(item.id, e.target.value)}
                                                                    />
                                                                </div>
                                                                <div className="gift-item-field gift-item-thumbnail-field">
                                                                    <label>썸네일</label>
                                                                    <div className="gift-item-upload">
                                                                        {item.preview && (
                                                                            <img
                                                                                src={item.preview}
                                                                                alt="gift preview"
                                                                                className="gift-item-preview"
                                                                            />
                                                                        )}
                                                                        <input
                                                                            id={giftImageInputId}
                                                                            type="file"
                                                                            accept="image/*"
                                                                            className="hidden-file-input"
                                                                            onChange={(e) => handleGiftImageChange(item.id, e.target.files[0])}
                                                                        />
                                                                        <label htmlFor={giftImageInputId} className="custom-label-file">
                                                                            파일첨부
                                                                        </label>
                                                                        <span className="gift-item-size-hint"><span>※</span> 이미지 규격 (32x32px)</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                className="gift-item-delete btn-remove-hv"
                                                                onClick={() => handleDeleteGiftItem(item.id)}
                                                            >
                                                                <TrashIcon />
                                                            </button>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <div className="bottom-content">
                        <div className="button-form">
                            <Link to={'/magac010'} className="btn btn-primary button-back-to-list">
                                목록
                            </Link>


                            {id && (
                                <button
                                    className="btn btn-primary button-back-to-list button-delete"
                                    onClick={() => {
                                        handleDelete();
                                    }}
                                >
                                    삭제
                                </button>
                            )}

                        </div>
                        <div className="button-form">
                            <button className="btn btn-primary button-save" onClick={handleSave}>
                                등록/수정
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MAGAC020;
